import React, { useContext } from "react";
import BottomNav from "../../components/Bottom nav/BottomNav";
import { Grid } from "@mui/material";
import CategoreyCard from "../../components/CategoreyCard";
import HomeIcon from "@mui/icons-material/Home";
import ShareIcon from "@mui/icons-material/Share";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import { variableContext } from "../../context/VariableContex";
import "./ListView.css";
import "./DarkBlueListTheme.css";
import useCommonQuery from "../../store/common/useCommonQuery";
import { useHistory } from "react-router-dom";

const CategoryListView = () => {
  const history = useHistory();
  const { layoutMode, setLayoutMode, selectedCategories, toggleSelectedCategory } = useContext(variableContext);
  const isListView = layoutMode === "list";
  const isGrid = layoutMode === "grid";
  const toggleLayout = () => setLayoutMode(isGrid ? "list" : "grid");
  const handleShare = async () => { try { await navigator.share({ url: window.location.href }); } catch (_) {} };

  const query = { limit: 1000, offset: 0 };
  const { data: categoryList } = useCommonQuery.Get_category(query);

  const handleClick = (id) => {
    const cat = categoryList?.data?.results?.find(c => c.id === id);
    if (cat) toggleSelectedCategory(cat);
    history.push(`/subcategory/${id}`);
  };

  return (
    <div id="parent-div" className={`clv-root ${isListView ? "is-list dark-blue-list" : "is-grid"} theme-light`}>

      {/* ── Header: [Home] [All Categories centered] [LayoutToggle] [Share] ── */}
      <div className="clv-header">
        <button className="clv-header-home-btn" onClick={() => history.push("/")} aria-label="Home">
          <HomeIcon sx={{ fontSize: "16px" }} />
        </button>
        <span className="clv-header-title">All Categories</span>
        <div className="clv-header-right">
          <div
            className={`header-layout-toggle ${isGrid ? "is-grid" : "is-list"}`}
            onClick={toggleLayout}
            title={isGrid ? "Switch to List View" : "Switch to Grid View"}
          >
            <div className="header-layout-toggle-thumb">
              {isGrid
                ? <ViewModuleIcon sx={{ fontSize: "13px" }} />
                : <ViewListIcon sx={{ fontSize: "13px" }} />}
            </div>
          </div>
          <button className="clv-header-share-btn" onClick={handleShare} aria-label="Share">
            <ShareIcon sx={{ fontSize: "16px" }} />
          </button>
        </div>
      </div>

      {/* ── Centered page body ── */}
      <div className="clv-body">

        <div className="clv-section-header">
          <h4 className="clv-section-title">All Categories</h4>
        </div>

        <Grid container spacing={2} className="clv-grid">
          {categoryList?.data?.results?.map((item) => (
            <CategoreyCard
              key={item.id}
              id={item.id}
              title={(
                <span style={{ color: (localStorage.getItem('pd-layout') === 'list') ? '#ffffff' : '#000000', fontSize: '12px' }}>
                  {item.name}
                </span>
              )}
              isGrid={isGrid}
              image={item.image}
              handleClick={handleClick}
              textColor={isGrid ? "#0B3D91" : undefined}
            />
          ))}
        </Grid>

      </div>

      <BottomNav />
    </div>
  );
};

export default React.memo(CategoryListView);
